import React from "react";
import SportCode from "components/common/SportCode";
import ScoresLiveCard from "components/common/ScoresLiveCard";
import moment from "moment";
import { isFinishedStatus, isLiveStatus } from "helpers/status";
import Label from "components/general/Label";
import { Link } from "react-router-dom";
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import { getEventRSC } from "helpers/rsc";
import useViewport from "components/general/useViewPort";
import SvgMirs from "components/presentation/SvgMirs";


export function Footer({ data }) {
    const durationValue = data?.result?.extendedInfos?.find(item => item?.ei_code === 'DURATION')?.ei_value;
    const duration = durationValue && durationMatch(durationValue)

    const getURL = useGetURL()

    let paramsURL = { ...useUrlFriendlyToParameters() }
    paramsURL["mirs_rsc"] = data?.eventUnit?.code
    if (!paramsURL["mirs_event"]) {
        paramsURL["mirs_event"] = getEventRSC(data?.eventUnit?.code)
    }
    const url = getURL({ ...paramsURL }, 'results')

    return (
        <><div className='scores-today-header'>
            <div className='scores-today-piste-tte'>
                <div className='flex-grow-1'>
                    <Label data="HeaderMatchDuration" />: {duration}
                </div>
                <Link to={url} className="text-decoration-none">
                    <div className='text-end fw-bold'>
                        <Label data="LabelMatchDetails" />
                    </div>
                </Link>
            </div>
        </div></>
    )
}

export function Header({ data }) {
    return (
        <><div className='scores-today-header'>
            <div className='scores-today-piste-tte'>
                <div className='flex-grow-1'>
                    {data?.eventUnit?.description}
                </div>
                <div className='text-end fw-bold'>
                    {data?.location?.shortDescription}
                </div>
            </div>
        </div></>
    )
}


export function CompetitorBlock(props) {
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs'

    const res = props?.resultDataText ? JSON.parse(props?.resultDataText) : {};
    const seed = res?.extra?.seed && ` (${res?.extra?.seed})`;
    const winnerbolding = res?.wlt?.trim() === 'W' && 'fw-bold';
    let competitor = <></>
    const dFlex = !isMobile ? ' d-flex ' : ''

    if (props?.itemType === 'A') {
        competitor = <div className="w-100"><Competitor {...props?.participant} hideNoc={true} hidePicture={true} noLink={true} /></div>
    } else {
        competitor = <div className="w-100"><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={props?.teamAthletes} /></div>
    }

    //Check if the game is singles or doubles    
    return (
        <div className={`score-competitor-container ${dFlex} justify-content-start text-truncate`}>
            <div className={`score-noc ${dFlex} align-items-center ${winnerbolding}`}>
                <Noc className='me-1' {...props?.participant?.organisation} />
                {props?.itemType !== 'A' && seed && <span><sup>{seed}</sup></span>}
            </div>
            <div className={`score-name ${dFlex} align-items-center ${winnerbolding}`}>
                {competitor}
                {props?.itemType === 'A' && seed && <span><sup>{seed}</sup></span>}
            </div>
        </div>
    )
}


export function CardsLayout({ results }) {

    const now = moment().utc();
    //const now = moment.parseZone('2024-07-28T15:00:00-05:00')?.utc();

    const filteredResults = results?.filter(item => isLiveStatus(item?.result.status.code) || (isFinishedStatus(item?.result.status.code) && showFinished(item?.endDate, now, 3)));

    const sortedResults = filteredResults?.sort((a, b) => {
        const diff_ = Number(a?.location?.locationOrder) - Number(b?.location?.locationOrder);
        if (diff_ !== 0) {
            return diff_
        } else {
            return a?.starDate > b?.starDate ? 1 : a?.starDate < b?.starDate ? -1 : 0
        }
    })

    return (
        <div className="d-flex flex-wrap">
            {
                sortedResults?.map(item => {
                    return (
                        <div key={item?.eventUnit?.code} className="w-90 ms-1">
                            <ScoresLiveCard data={item} />
                        </div>
                    )
                })
            }
        </div>
    );
}

export function BodyComponent({ data, competitorComponent, competitorNoDataComponent }) {
    const { breakPoint } = useViewport()
    const isMobile = breakPoint === 'sm' || breakPoint === 'xs'
    return isMobile ? <BodyMobile data={data} competitorComponent={competitorComponent} competitorNoDataComponent={competitorNoDataComponent} /> : <BodyDesktop data={data} competitorComponent={competitorComponent} competitorNoDataComponent={competitorNoDataComponent} />
}

const showFinished = (endDateValue, now, lapse) => {
    const endDate = moment.parseZone(endDateValue)?.utc()
    const duration = moment.duration(endDate?.diff(now));
    const minutes = duration?.asMinutes();
    return minutes <= lapse;
}

const durationMatch = durationValue => {
    const startDate = moment('00:00', 'h:mm')
    const endDate = moment(durationValue, 'h:mm')
    const duration = moment.duration(endDate?.diff(startDate));
    return duration.format('h[h]:mm[min]')

}

const BodyDesktop = ({ data, competitorComponent, competitorNoDataComponent }) => {
    const CompetitorComponent = competitorComponent || <></>
    const CompetitorNoDataComponent = competitorNoDataComponent || <></>
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const getURL = useGetURL()

    let paramsURL = { ...useUrlFriendlyToParameters() }
    paramsURL["mirs_rsc"] = data?.eventUnit?.code
    if (!paramsURL["mirs_event"]) {
        paramsURL["mirs_event"] = getEventRSC(data?.eventUnit?.code)
    }
    const url = getURL({ ...paramsURL }, 'results')

    const sortedItems = data?.result?.items.sort((a, b) => a.sortOrder - b.sortOrder);

    const out = sortedItems?.map(item => {
        const res = item?.resultDataText ? JSON.parse(item?.resultDataText) : {};
        const boldingSetWinner = ["", res?.extra?.winS1, res?.extra?.winS2, res?.extra?.winS3].map(item => item && 'fw-bold');
        const winner = res?.wlt?.trim() === 'W' && <SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' />
        const irm = res?.hasIRM === true && <SportCode discipline={mirs_discipline} code={res?.irm} entity="@IRM" abbr={true} />
        const showServeIcon = res?.hasIRM === false && res?.wlt?.trim() !== 'W' && res?.extra?.current?.includes('true') > 0
        const isOrder2 = showServeIcon && res?.extra?.athNumber === '2' && res?.extra?.currentAthOrder === '2' && <br />
        const serveIcon = showServeIcon && <span className="mirsIconTENball"></span>
        const resultS1 = (res?.extra?.resultS1 && res?.extra?.resultS1.includes('('))
            ? <> {res?.extra?.resultS1.substring(0, res?.extra?.resultS1.indexOf('('))}
                <sup>{res?.extra?.resultS1.substring(res?.extra?.resultS1.indexOf('('), res?.extra?.resultS1.indexOf(')') + 1)}</sup>
            </>
            : <>{res?.extra?.resultS1}</>

        const resultS2 = (res?.extra?.resultS2 && res?.extra?.resultS2.includes('('))
            ? <> {res?.extra?.resultS2.substring(0, res?.extra?.resultS2.indexOf('('))}
                <sup>{res?.extra?.resultS2.substring(res?.extra?.resultS2.indexOf('('), res?.extra?.resultS2.indexOf(')') + 1)}</sup>
            </>
            : <>{res?.extra?.resultS2}</>

        return (
            <div className="row" key={item?.sortOrder}>
                <div className="col-5">
                    {item?.participant ? <CompetitorComponent extendedInfos={data?.result?.extendedInfos} {...item} /> : <CompetitorNoDataComponent {...item} />}
                </div>
                <div className="col-7">
                    <div className="row">
                        {showServeIcon && <div className="col-4 fw-bold">{isOrder2}{serveIcon}</div>}
                        {!showServeIcon && <div className="col-4 fw-bold">{winner} {irm}</div>}
                        <div className="col-2 text-center">{res?.extra?.resultCurrent}</div>
                        <div className={`col-2 text-center ${boldingSetWinner[1]}`}>{resultS1}</div>
                        <div className={`col-2 text-center ${boldingSetWinner[2]}`}>{resultS2}</div>
                        <div className={`col-2 text-center ${boldingSetWinner[3]}`}>{res?.extra?.resultTieBreakS3 ? `[${res?.extra?.resultTieBreakS3}]` : res?.extra?.resultS3}</div>
                    </div>
                </div>
            </div>
        )
    })

    return (
        <Link to={url} className="text-decoration-none">
            <div className="container">
                <div className="row">
                    <div className="col-5"></div>
                    <div className="col-7">
                        <div className="row">
                            <div className={`col-4 text-center`}></div>
                            <div className={`col-2 text-center`}><Label data="HeaderSortPoints" /></div>
                            <div className={`col-2 text-center`}><Label data="Header1st" /></div>
                            <div className={`col-2 text-center`}><Label data="Header2nd" /></div>
                            <div className={`col-2 text-center`}><Label data="Header3rd" /></div>
                        </div>
                    </div>
                </div>
                {out}
            </div>
        </Link>
    )
}

const BodyMobile = ({ data, competitorComponent, competitorNoDataComponent }) => {
    const CompetitorComponent = competitorComponent || <></>
    const CompetitorNoDataComponent = competitorNoDataComponent || <></>
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const getURL = useGetURL()

    let paramsURL = { ...useUrlFriendlyToParameters() }
    paramsURL["mirs_rsc"] = data?.eventUnit?.code
    if (!paramsURL["mirs_event"]) {
        paramsURL["mirs_event"] = getEventRSC(data?.eventUnit?.code)
    }
    const url = getURL({ ...paramsURL }, 'results')

    const sortedItems = data?.result?.items.sort((a, b) => a.sortOrder - b.sortOrder);

    const out1 = sortedItems?.map(item => {
        const res = item?.resultDataText ? JSON.parse(item?.resultDataText) : {};
        const winner = res?.wlt?.trim() === 'W' && <SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' />
        const irm = res?.hasIRM === true && <SportCode discipline={mirs_discipline} code={res?.irm} entity="@IRM" abbr={true} />
        const showServeIcon = res?.hasIRM === false && res?.wlt?.trim() !== 'W' && res?.extra?.current?.includes('true') > 0
        const isOrder2 = showServeIcon && res?.extra?.athNumber === '2' && res?.extra?.currentAthOrder === '2' && <br />
        const serveIcon = showServeIcon && <span className="mirsIconTENball"></span>
        return (
            <div className="row" key={item?.sortOrder}>
                <div className="col-10">
                    {item?.participant ? <CompetitorComponent extendedInfos={data?.result?.extendedInfos} {...item} /> : <CompetitorNoDataComponent {...item} />}
                </div>
                {showServeIcon ? (
                    <div className="col-2 fw-bold">
                        {isOrder2}{serveIcon}
                    </div>
                ) : (
                    <div className="col-2 fw-bold">
                        {winner} {irm}
                    </div>
                )}
            </div>
        )

    })

    const out2 = sortedItems?.map(item => {
        const res = item?.resultDataText ? JSON.parse(item?.resultDataText) : {};
        const boldingSetWinner = ["", res?.extra?.winS1, res?.extra?.winS2, res?.extra?.winS3].map(item => item && 'fw-bold');

        const resultS1 = (res?.extra?.resultS1 && res?.extra?.resultS1.includes('('))
            ? <> {res?.extra?.resultS1.substring(0, res?.extra?.resultS1.indexOf('('))}
                <sup>{res?.extra?.resultS1.substring(res?.extra?.resultS1.indexOf('('), res?.extra?.resultS1.indexOf(')') + 1)}</sup>
            </>
            : <>{res?.extra?.resultS1}</>

        const resultS2 = (res?.extra?.resultS2 && res?.extra?.resultS2.includes('('))
            ? <> {res?.extra?.resultS2.substring(0, res?.extra?.resultS2.indexOf('('))}
                <sup>{res?.extra?.resultS2.substring(res?.extra?.resultS2.indexOf('('), res?.extra?.resultS2.indexOf(')') + 1)}</sup>
            </>
            : <>{res?.extra?.resultS2}</>

        return (
            <div className="row" key={item?.sortOrder}>
                <div className="col-3 text-center">{res?.extra?.resultCurrent}</div>
                <div className={`col-3 text-center ${boldingSetWinner[1]}`}>{resultS1}</div>
                <div className={`col-3 text-center ${boldingSetWinner[2]}`}>{resultS2}</div>
                <div className={`col-3 text-center ${boldingSetWinner[3]}`}>{res?.extra?.resultTieBreakS3 ? `[${res?.extra?.resultTieBreakS3}]` : res?.extra?.resultS3}</div>
            </div>
        )
    })
    return (
        <Link to={url} className="text-decoration-none">
            <div className="container">
                {out1}
                <div className="row">
                    <div className={`col-3 text-center`}><Label data="HeaderSortPoints" /></div>
                    <div className={`col-3 text-center`}><Label data="Header1st" /></div>
                    <div className={`col-3 text-center`}><Label data="Header2nd" /></div>
                    <div className={`col-3 text-center`}><Label data="Header3rd" /></div>
                </div>
                {out2}
            </div>
        </Link>
    )
}
